import { render, staticRenderFns } from "./ClientHandle.vue?vue&type=template&id=0f036e7c&scoped=true&"
import script from "./ClientHandle.vue?vue&type=script&lang=js&"
export * from "./ClientHandle.vue?vue&type=script&lang=js&"
import style0 from "./ClientHandle.vue?vue&type=style&index=0&id=0f036e7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f036e7c",
  null
  
)

export default component.exports